import { connect } from 'react-redux';
import {
  finishOverwriteTimeslot,
  setTimeslotRequest, 
  startOverwriteTimeslot, 
  toggleDeleteAppointmentModal
} from "../../../redux/timeslots/actions";
import DeleteAppointment from "./DeleteAppointment";

const mapStateToProps = (state) => ({
  selectedTimeslot: state.timeslotsReducer.selectedTimeslot,
  recurrenceRule: state.timeslotsReducer.recurrenceRule,
  currentDate: state.reservationReducer.currentDate,
  deleteAppointmentModalIsOpen: state.timeslotsReducer.deleteAppointmentModalIsOpen,
  currentAppointment: state.timeslotsReducer.currentAppointment,
  isConfigurationFetching: state.reservationReducer.isConfigurationFetching,
  isDayPage: state.timeslotsReducer.isDayPage
});

const mapDispatchToProps = {
  setTimeslotRequest,
  toggleDeleteAppointmentModal,
  startOverwriteTimeslot,
  finishOverwriteTimeslot
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAppointment);
